import { DemeterFeatureType } from '../../Generated/Raven-Demeter';
import DashboardCustomizationPage from '../../Refactor/Pages/DashboardCustomization/DashboardCustomizationPage';
import useFeatureFlag from '../../Refactor/Services/FeatureFlags/useFeatureFlagHook';
import DashboardPage from './DashboardPage';

const DashboardPageContainer: React.FC = () => {
    const isDashboardCustomizationPageOn = useFeatureFlag(DemeterFeatureType.DashboardCustomization);

    return <div>{isDashboardCustomizationPageOn ? <DashboardCustomizationPage /> : <DashboardPage />}</div>;
};

export default DashboardPageContainer;
